import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClockIcon, FlameIcon, UsersIcon } from 'lucide-react';
import { useSharedCountdown } from './CountdownTimer';
export function UrgencyModule() {
  const secondsLeft = useSharedCountdown();
  const TOTAL_SPOTS = 50;
  const [spotsLeft, setSpotsLeft] = useState(23);
  useEffect(() => {
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 4) return prev;
        return Math.random() < 0.25 ? prev - 1 : prev;
      });
    }, 12000);
    return () => clearInterval(spotsTimer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const hours = 0;
  const percentLeft = spotsLeft / TOTAL_SPOTS * 100;
  return <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-900 via-red-950 to-black py-12 px-4 border-y-4 border-red-600 relative overflow-hidden shadow-[0_0_40px_rgba(220,38,38,0.2)]" data-id="element-538" data-mp="2cmq9eosf6rt4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-539" data-mp="1137q527wm465"></div>
      <div className="max-w-4xl mx-auto" data-id="element-540" data-mp="w3urzlbl1ao9">
        {/* Top alert badge */}
        <div className="flex justify-center mb-5" data-id="element-541" data-mp="1arzfd2lkyadd">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-xs md:text-sm px-4 py-2 rounded-full uppercase tracking-wider shadow-lg shadow-red-900/50 ring-2 ring-red-400/40" data-id="element-542" data-mp="15txucc4lg0z9">
            <FlameIcon className="h-4 w-4 animate-pulse" data-id="element-543" data-mp="d5ifpqpdjkog" />
            ¡Atención! Oferta a punto de finalizar
          </div>
        </div>

        {/* Main headline */}
        <h2 className="text-3xl md:text-5xl font-black text-center mb-3 uppercase leading-tight" data-id="element-544" data-mp="r2x9f7mnuem8">
          <span className="text-white" data-id="element-545" data-mp="n5j3ppy6uoyz">Aprovechá el</span>{' '}
          <span className="text-red-400 drop-shadow-[0_0_14px_rgba(239,68,68,0.7)]" data-id="element-546" data-mp="22j5izt0ieq7e">
            60% OFF
          </span>
          <br data-id="element-547" data-mp="1yibt4u3ib1bv" />
          <span className="text-white text-2xl md:text-3xl font-bold" data-id="element-548" data-mp="1yko7yydywvkp">
            antes de que termine
          </span>
        </h2>

        <p className="text-center text-red-100/80 text-sm md:text-base mb-8" data-id="element-549" data-mp="10698uk5tdubb">
          Esta promoción es exclusiva y limitada. Cuando el reloj llegue a cero
          o se agoten los cupos, vuelve al precio regular.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-2" data-id="element-550" data-mp="1965su8h9e501">
          {/* Countdown Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-551" data-mp="ci96so31yhhf">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-552" data-mp="he6qn4diy5yy">
              <AlarmClockIcon className="h-5 w-5 text-red-400" data-id="element-553" data-mp="lgbh5u8oemhd" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-554" data-mp="q94h84t796n4">
                La oferta expira en
              </p>
            </div>
            <div className="flex justify-center gap-2 md:gap-3" data-id="element-555" data-mp="3pu02h5wwut9o">
              {[{
              value: hours,
              label: 'Horas'
            }, {
              value: minutes,
              label: 'Minutos'
            }, {
              value: seconds,
              label: 'Segundos'
            }].map((unit, i) => <Fragment key={unit.label} data-id="element-556" data-mp="3ddgvvaurxem8" data-mpi={i}>
                  <div className="flex flex-col items-center" data-id="element-557" data-mp="3dc5utispqkyt">
                    <div className="bg-black border-2 border-red-600/70 rounded-lg px-3 md:px-5 py-2 md:py-3 shadow-[0_0_15px_rgba(239,68,68,0.3)] min-w-[60px] md:min-w-[80px]" data-id="element-558" data-mp="38enswcd4560b">
                      <span className="text-3xl md:text-5xl font-black text-red-400 tabular-nums tracking-tight drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-559" data-mp="33h5lwrinp0uy">
                        {String(unit.value).padStart(2, '0')}
                      </span>
                    </div>
                    <span className="text-[10px] md:text-xs text-red-200/70 mt-2 uppercase tracking-wider font-semibold" data-id="element-560" data-mp="2pph5wd5ads8p">
                      {unit.label}
                    </span>
                  </div>
                  {i < 2 && <span className="text-3xl md:text-5xl font-black text-red-500 self-start mt-1 md:mt-2" data-id="element-561" data-mp="2frtb5n7okkqj">
                      :
                    </span>}
                </Fragment>)}
            </div>
          </div>

          {/* Spots Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-562" data-mp="9xk6pdeggtob">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-563" data-mp="eu0xyggybo5m">
              <UsersIcon className="h-5 w-5 text-red-400" data-id="element-564" data-mp="vazawehhgf5" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-565" data-mp="4xfqzpldg2z5">
                Cupos disponibles
              </p>
            </div>
            <div className="text-center mb-3" data-id="element-566" data-mp="3n555lfhsh4kf">
              <span className="text-5xl md:text-6xl font-black text-white tabular-nums" data-id="element-567" data-mp="3s25fk1hrergt">
                {spotsLeft}
              </span>
              <span className="text-2xl md:text-3xl font-bold text-red-200/50" data-id="element-568" data-mp="1ld8si1fz3mnj">
                {' '}
                / {TOTAL_SPOTS}
              </span>
            </div>
            {/* Progress bar */}
            <div className="relative w-full h-3 bg-red-950 rounded-full overflow-hidden border border-red-700/60" data-id="element-569" data-mp="3atkuqeyw9c0p">
              <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-700 via-red-500 to-red-400 rounded-full transition-all duration-1000 ease-out shadow-[0_0_12px_rgba(239,68,68,0.8)]" style={{
              width: `${percentLeft}%`
            }} data-id="element-570" data-mp="35rvjay7rewc3" />
            </div>
            <p className="text-center text-xs text-red-200/80 mt-3 font-semibold" data-id="element-571" data-mp="3thzkz01e0m0g">
              {spotsLeft <= 10 ? <span className="text-red-300 font-bold uppercase" data-id="element-572" data-mp="3ojy1wf3yomoz">
                  ⚠️ ¡Quedan muy pocos! Asegurá el tuyo ya
                </span> : <>
                  Se están agotando rápido —{' '}
                  <span className="text-red-300 font-bold" data-id="element-573" data-mp="2e14zpxfmbqe">
                    {TOTAL_SPOTS - spotsLeft} ya tomados
                  </span>
                </>}
            </p>
          </div>
        </div>

        {/* Bottom warning */}
        <div className="text-center mt-6" data-id="element-574" data-mp="2tt1klrgt8dgp">
          <p className="text-red-100/90 text-sm md:text-base" data-id="element-575" data-mp="2tu36ys3a0mdq">
            🔒 Una vez que el contador llegue a 00:00,{' '}
            <span className="text-red-300 font-bold" data-id="element-576" data-mp="2xwg1ekckoxv7">
              esta oferta desaparece
            </span>{' '}
            y el precio sube a <span className="line-through" data-id="element-577" data-mp="37s9ouyrtybrr">ARS 84.990</span>
          </p>
        </div>
      </div>
    </section>;
}